export const LOGIN_FORM = 'LOGIN_FORM';
export const REGISTER_FORM = 'REGISTER_FORM';
export const PRICE_OPTS_FORM = 'PRICE_OPTS_FORM';
export const PAYMENTS_FORM = 'PAYMENTS_FORM';
export const FORGOT_PASSWORD_FORM = 'FORGOT_PASSWORD_FORM';
export const MY_ACCOUNT_FORM = 'MY_ACCOUNT_FORM';
export const PAYMENT_PROCESSOR_FORM = 'PAYMENT_PROCESSOR_FORM';
export const CHANGE_PASSWORD_FORM = 'CHANGE_PASSWORD_FORM';
export const DELETE_ACCOUNT_FORM = 'DELETE_ACCOUNT_FORM';
export const EXPORT_DATA_FORM = 'EXPORT_DATA_FORM';
export const SET_NEW_PASSWORD_FORM = 'SET_NEW_PASSWORD_FORM';
export const CONFIRM_GDPR_DELETE_FORM = 'CONFIRM_GDPR_DELETE_FORM';
export const CONFIRM_GDPR_EXPORT_FORM = 'CONFIRM_GDPR_EXPORT_FORM';
export const PURCHASE_HISTORY_FORM = 'PURCHASE_HISTORY_FORM';
export const SUBSCRIPTIONS_FORM = 'SUBSCRIPTIONS_FORM';
export const UNSUBSCRIBE_FORM = 'UNSUBSCRIBE_FORM';

export const VALID_FORMS = [
    LOGIN_FORM,
    REGISTER_FORM,
    PRICE_OPTS_FORM,
    FORGOT_PASSWORD_FORM,
    PAYMENTS_FORM,
    MY_ACCOUNT_FORM,
    PAYMENT_PROCESSOR_FORM,
    CHANGE_PASSWORD_FORM,
    DELETE_ACCOUNT_FORM,
    EXPORT_DATA_FORM,
    SET_NEW_PASSWORD_FORM,
    CONFIRM_GDPR_DELETE_FORM,
    CONFIRM_GDPR_EXPORT_FORM,
    PURCHASE_HISTORY_FORM,
    SUBSCRIPTIONS_FORM,
    UNSUBSCRIBE_FORM,
];



// WEBPACK FOOTER //
// ./src/constants/forms.js